/**!
 * Created by Leonardo Cheslacki on 08/03/2024.
 *
 * MIT License
 *
 * Copyright (c) 2024 cheslacki
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

module.exports.scene = {
    layerActions: {
        /**
         * this.window = window;
         * const StageClass = window.StageClass;
         * StageClass.sun.scene.layerActions.frame01Character(this, 'current_name');
         * @param _this
         * @param current_name
         */
        frame01Login: (_this, current_name) => {
            /**
             *
             *  @param object
             *  Set "this", object of canvas CreateJs.
             */
            AllTap.setState({...AllTap.state, [`_this_${current_name}`]: _this}, () => {

                const authWelcome = AllTap.$authWelcome({current_name: current_name});

                authWelcome.init();
            });
        },
    }
};

// module.exports.login = {
//     form: (_document) => {
//         const
//             helpersAlert = AllTap.$helpersAlert({document: _document}),
//             helpersElement = AllTap.$helpersElement({document: _document}),
//             helpersError = AllTap.$helpersError({document: _document}),
//             helpersSpinner = AllTap.$helpersSpinner({document: _document, className: 'button-submit'});
//
//         /**
//          *
//          * @param event
//          */
//         const submit = (event) => {
//             AllTap.stopPropagation(event);
//
//             let form = helpersElement.getById('form_login');
//
//             if (!AllTap.isEmpty(form)) {
//                 AllTap.postForm(form.wantAttribute('action'), {auth: form.wantInputs().wantJson()}, {
//                     beforeSend: () => {
//                         helpersSpinner.start();
//                     },
//                     done: ({status, alert, errors, message, route}) => {
//                         if (Boolean(status)) {
//                             AllTap.redirectRoute(route);
//                         } else {
//                             helpersAlert.alertError(message, alert);
//                             helpersError.setErrors(errors);
//                         }
//                     },
//                     fail: (response) => {
//                         console.log(response);
//                     },
//                     always: () => {
//                         helpersSpinner.stop();
//                     }
//                 });
//             }
//         };
//
//         /**
//          *
//          *  Add event in the button for start.
//          */
//         AllTap.removeListener('click', 'form-login-button-submit', submit, () => {
//             AllTap.addListener(helpersElement.getByClass('button-submit'), 'click', 'form-login-button-submit', submit);
//         });
//     }
// };
//
// module.exports.after = {
//     progressAvatar: (_document, avatar, score) => {
//         AllTap.progressAvatar(_document, avatar, score);
//         AllTap.redirectRoute(`${location.protocol}//${location.host}/student/dashboard`, 5000);
//     }
// };
//
// module.exports.recovery = {
//     autocomplete: (_document) => {
//         AllTap.autocompleteSelect('auth_uf', 'auth_city', '/api/cities/');
//         AllTap.autocompleteSelect('auth_city', 'auth_institution', '/api/institutions/');
//     },
//     form: (_document) => {
//         const
//             helpersAlert = AllTap.$helpersAlert({document: _document}),
//             helpersElement = AllTap.$helpersElement({document: _document}),
//             helpersError = AllTap.$helpersError({document: _document}),
//             helpersSpinner = AllTap.$helpersSpinner({document: _document, className: 'button-submit'});
//
//         /**
//          *
//          * @param event
//          */
//         const submit = (event) => {
//             AllTap.stopPropagation(event);
//
//             let form = helpersElement.getById('form_recovery');
//
//             if (!AllTap.isEmpty(form)) {
//                 AllTap.postForm(form.wantAttribute('action'), {auth: form.wantInputs().wantJson()}, {
//                     beforeSend: () => {
//                         helpersSpinner.start();
//                     },
//                     done: ({status, alert, errors, message, route}) => {
//                         if (Boolean(status)) {
//                             AllTap.redirectRoute(route);
//                         } else {
//                             helpersAlert.alertError(message, alert);
//                             helpersError.setErrors(errors);
//                         }
//                     },
//                     fail: (response) => {
//                         console.log(response);
//                     },
//                     always: () => {
//                         helpersSpinner.stop();
//                     }
//                 });
//             }
//         };
//
//         /**
//          *
//          *  Add event in the button for start.
//          */
//         AllTap.removeListener('click', 'form-recovery-button-submit', submit, () => {
//             AllTap.addListener(helpersElement.getByClass('button-submit'), 'click', 'form-recovery-button-submit', submit);
//         });
//     }
// };
